import React from 'react';
import I18n from 'i18n-js';
import RecentArticles from './recent_articles';
import HomepageCategories from '../homepage_categories';
import HomepageSell from './homepage_sell';
import HomepageNewsletter from './homepage_newsletter';
import HomepageMosaic from './homepage_mosaic';
import SiteBannerHeroContainer from '../site_banner_hero_container';
import HomePageSellVisibilityV2 from './homepage_sell_visibility_v2';

import RecentlyViewedListings from '@reverbdotcom/commons/src/cms/components/recently_viewed_listings';
import CmsListingsCollection from '@reverbdotcom/commons/src/cms/components/cms_listings_collection';
import CmsEmbed from '@reverbdotcom/commons/src/components/cms_embed';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';

import HomepageDealsAndStealsListingsCollection from '../../homepage_deals_and_steals_listings_collection';

export function LoggedOutHomepage() {
  const user = useUser();

  return (
    <>
      <SiteBannerHeroContainer />
      <HomepageMosaic />
      <div className="homepage bg-white pt-half">
        <div className="homepage-container__component-wrapper">
          <RecentlyViewedListings
            title={I18n.t('discovery.recentlyViewed.title')}
            largeTiles
          />
        </div>
        <HomePageSellVisibilityV2 />
        <div className="homepage-container__component-wrapper">
          <CmsEmbed slug="homepage-embed" ssrMode="static-only" />
        </div>
        <h2 className="homepage__subheading">
          {I18n.t('discovery.homepage.loggedOutNew.shopByInstrument')}
        </h2>
        <div className="homepage-container__component-wrapper homepage-container__component-wrapper--thin">
          <HomepageCategories noTitle />
        </div>
        <div className="homepage-container__component-wrapper">
          <h2 className="homepage__subheading">
            {I18n.t('discovery.homepage.loggedOutNew.explore')}
          </h2>
          <RecentArticles title=" " />
        </div>
        <div className="scaling-mb-7 scaling-mt-10">
          <HomepageNewsletter signupReason="loggedouthomepage" />
        </div>
        <div className="homepage-container__component-wrapper">
          <h2 className="homepage__subheading">
            {I18n.t('discovery.homepage.loggedOutNew.latestGear')}
          </h2>
          <CmsListingsCollection
            ctaTargetHref="/marketplace?condition=used"
            conditionSlugs={['used']}
            userShippingRegion={user.shippingRegionCode}
            componentName="HomepageLatestListings"
            maxCount={12}
            largeTiles
            ssr={false}
          />
        </div>
        <div className="homepage-container__component-wrapper">
          <h2 className="homepage__subheading">
            {I18n.t('discovery.homepage.loggedOutNew.dealsAndSteals')}
          </h2>
          <HomepageDealsAndStealsListingsCollection />
        </div>
        <div className="scaling-mt-10 pb-5 mobile-pb-0">
          <HomepageSell />
        </div>
      </div>
    </>
  );
}

export default LoggedOutHomepage;
